import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-upgrade-modal",
  template: `
    <app-custom-overlay
      *ngIf="isVisible"
      [closeOnBackdropClick]="false"
      (backdropClick)="onMaybeLater()"
    >
      <div class="upgrade-modal">
        <button
          class="close-button"
          (click)="onMaybeLater()"
          [disabled]="isUpgrading"
        >
          <span class="material-icons">close</span>
        </button>

        <h2>Feature Update Available</h2>
        <p class="feature-name">{{ featureName }}</p>

        <div class="version-info">
          <div class="version-row">
            <span class="version-label">Current:</span>
            <span class="version-value">{{ currentVersion }}</span>
          </div>
          <div class="version-row">
            <span class="version-label">New:</span>
            <span class="version-value">{{ newVersion }}</span>
          </div>
        </div>

        <p class="message">
          A new version of this feature is available. Would you like to upgrade
          now?
        </p>

        <div class="button-container">
          <button
            class="btn btn-primary"
            (click)="onUpgrade()"
            [disabled]="isUpgrading"
          >
            <span *ngIf="!isUpgrading">Upgrade Now</span>
            <span *ngIf="isUpgrading" class="upgrading">
              <span class="spinner"></span>
              Upgrading...
            </span>
          </button>
        </div>
      </div>
    </app-custom-overlay>
  `,
  styles: [
    `
      .upgrade-modal {
        padding: 24px;
        position: relative;
      }

      .close-button {
        position: absolute;
        top: 12px;
        right: 12px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        color: #666;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: background-color 0.2s;
      }

      .close-button:hover:not(:disabled) {
        background-color: #f5f5f5;
      }

      .close-button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      h2 {
        margin: 0 0 8px 0;
        font-size: 20px;
        font-weight: 600;
        color: #333;
      }

      .feature-name {
        font-size: 16px;
        font-weight: 500;
        color: #1976d2;
        margin: 0 0 20px 0;
      }

      .version-info {
        background-color: #f5f5f5;
        border-radius: 8px;
        padding: 16px;
        margin: 0 0 20px 0;
      }

      .version-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
      }

      .version-row:last-child {
        margin-bottom: 0;
      }

      .version-label {
        font-weight: 600;
        color: #666;
      }

      .version-value {
        color: #333;
        font-family: monospace;
        font-size: 13px;
      }

      .message {
        margin: 0 0 24px 0;
        font-size: 14px;
        color: #555;
        line-height: 1.6;
      }

      .button-container {
        display: flex;
        gap: 12px;
        justify-content: flex-end;
      }

      .btn {
        padding: 10px 20px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        border: none;
        transition: all 0.2s;
        min-width: 120px;
      }

      .btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }

      .btn-secondary {
        background-color: #f5f5f5;
        color: #666;
      }

      .btn-secondary:hover:not(:disabled) {
        background-color: #e0e0e0;
      }

      .btn-primary {
        background-color: #1976d2;
        color: white;
      }

      .btn-primary:hover:not(:disabled) {
        background-color: #1565c0;
      }

      .upgrading {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }

      .spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-top-color: white;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `,
  ],
})
export class UpgradeModalComponent {
  @Input() isVisible = false;
  @Input() featureName = "Feature";
  @Input() currentVersion = "";
  @Input() newVersion = "";
  @Input() isUpgrading = false;

  @Output() upgrade = new EventEmitter<void>();
  @Output() maybeLater = new EventEmitter<void>();

  onUpgrade() {
    this.upgrade.emit();
  }

  onMaybeLater() {
    this.maybeLater.emit();
  }
}
